/**
 * Created by lu on 2018/4/9.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent: require('../../../../model/product/ProductItem'),
    method: {
        init: function () {

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/products/ProductItem.js
// module id = 111
// module chunks = 6 33 34